<template>
  <button
    class="flex items-center justify-center fixed rounded-full text-white cursor-pointer shadow-lg transition-colors"
    :class="[positionClasses, colorClasses, sizeClasses]"
    @click="$emit('click')"
  >
    <SvgIcon :icon="icon" :size="iconSize" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BG_TINT_COLOR_MAP, HOVER_BG_TINT_COLOR_MAP } from '@/constants/theme'
import SvgIcon from '@/components/misc/SvgIcon'
import type { ColorTint } from '@/types/components/common'

interface Props {
  icon: string
  color?: ColorTint
  size?: 'sm' | 'md' | 'lg'
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'red',
  size: 'md',
  position: 'bottom-right',
})

defineEmits<{
  click: []
}>()

const positionClasses = computed(() => {
  switch (props.position) {
    case 'bottom-right':
      return 'right-6 bottom-6'
    case 'bottom-left':
      return 'left-6 bottom-6'
    case 'top-right':
      return 'right-6 top-6'
    case 'top-left':
      return 'left-6 top-6'
    default:
      return 'right-6 bottom-6'
  }
})

const colorClasses = computed(() => {
  return `${BG_TINT_COLOR_MAP[props.color]} ${HOVER_BG_TINT_COLOR_MAP[props.color]}`
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'w-4 h-4'
    case 'md':
      return 'w-6 h-6'
    case 'lg':
      return 'w-8 h-8'
    default:
      return 'w-6 h-6'
  }
})

const iconSize = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'sm'
    case 'md':
      return 'md'
    case 'lg':
      return 'lg'
    default:
      return 'lg'
  }
})
</script>
